import React from "react";

import { isZh } from "../../utils/language";

export default function PreRegDynamicFields({
  fields,
  customValues,
  setCustomValues,
  setStep,
  registrationRole,
}) {

  return (
    <>

      <div className="section-card">

        {fields
          .filter((f) => {

            if (
              f.scope === "all"
            ) {
              return true;
            }

            return (
              f.scope === registrationRole
            );
          })
          .map((f) => {

          const type =
            normalizeType(f.type);

          const value =
            customValues?.[f.id];

          const label =
            isZh()
              ? (
                f.labelZh ||
                f.labelId
              )
              : (
                f.labelId ||
                f.labelZh
              );

          const description =
            isZh()
              ? (
                f.descZh ||
                f.descId
              )
              : (
                f.descId ||
                f.descZh
              );

          return (
            <div
              key={f.id}
              className="field-wrap"
            >

              <label className="field-label">

                {label}

                {f.required && (
                  <span className="required-mark">
                    {" "}*
                  </span>
                )}

              </label>

              {description && (
                <div className="field-desc">
                  {description}
                </div>
              )}

              {type === "text" && (
                <input
                  className="field-input"
                  type="text"
                  value={value || ""}
                  onChange={(e) =>
                    updateValue(
                      f.id,
                      e.target.value,
                      setCustomValues
                    )
                  }
                />
              )}

              {type === "textarea" && (
                <textarea
                  className="field-input textarea"
                  value={value || ""}
                  onChange={(e) =>
                    updateValue(
                      f.id,
                      e.target.value,
                      setCustomValues
                    )
                  }
                />
              )}

              {type === "number" && (
                <input
                  className="field-input"
                  type="number"
                  value={value || ""}
                  onChange={(e) =>
                    updateValue(
                      f.id,
                      e.target.value,
                      setCustomValues
                    )
                  }
                />
              )}

              {type === "date" && (
                <input
                  className="field-input"
                  type="date"
                  value={value || ""}
                  onChange={(e) =>
                    updateValue(
                      f.id,
                      e.target.value,
                      setCustomValues
                    )
                  }
                />
              )}

              {type === "select" && (
                <select
                  className="field-input"
                  value={value || ""}
                  onChange={(e) =>
                    updateValue(
                      f.id,
                      e.target.value,
                      setCustomValues
                    )
                  }
                >

                  <option value="">
                    --
                  </option>

                  {(f.options || []).map((o) => (
                    <option
                      key={o}
                      value={o}
                    >
                      {o}
                    </option>
                  ))}

                </select>
              )}

              {type === "radio" && (
                <div className="radio-group">

                  {(f.options || []).map((o) => (

                    <label
                      key={o}
                      className="radio-item"
                    >

                      <input
                        type="radio"
                        checked={value === o}
                        onChange={() =>
                          updateValue(
                            f.id,
                            o,
                            setCustomValues
                          )
                        }
                      />

                      <span>
                        {o}
                      </span>

                    </label>

                  ))}

                </div>
              )}

            </div>
          );
        })}

      </div>

      <div className="bottom-actions">

        <button
          type="button"
          className="btn-secondary"
          onClick={() => setStep(1)}
        >
          {isZh()
            ? "返回"
            : "Kembali"}
        </button>

        <button
          type="button"
          className="btn-primary"
          onClick={() => setStep(3)}
        >
          {isZh()
            ? "下一步"
            : "Lanjut"}
        </button>

      </div>

      <style>{`

        .section-card{
          background:#fff;
          border:1px solid #dbe3ef;
          border-radius:1rem;
          padding:1rem;
        }

        .field-wrap{
          margin-bottom:1.2rem;
        }

        .field-label{
          display:block;
          margin-bottom:0.35rem;
          font-size:0.9rem;
          font-weight:600;
        }

        .required-mark{
          color:#dc2626;
        }

        .field-desc{
          font-size:0.78rem;
          color:#64748b;
          margin-bottom:0.5rem;
        }

        .field-input{
          width:100%;
          border:1px solid #cbd5e1;
          border-radius:0.8rem;
          padding:0.75rem 0.9rem;
          font-size:0.95rem;
          background:#fff;
        }

        .textarea{
          min-height:7rem;
          resize:vertical;
        }

        .radio-group{
          display:flex;
          flex-direction:column;
          gap:0.7rem;
        }

        .radio-item{
          display:flex;
          align-items:center;
          gap:0.6rem;
          font-size:0.92rem;
        }

        .bottom-actions{
          display:flex;
          justify-content:space-between;
          margin-top:1.5rem;
        }

        .btn-primary{
          border:none;
          background:#2563eb;
          color:#fff;
          border-radius:0.7rem;
          padding:0.75rem 1.2rem;
          font-size:0.9rem;
          font-weight:600;
          cursor:pointer;
        }

        .btn-secondary{
          border:1px solid #cbd5e1;
          background:#fff;
          color:#111827;
          border-radius:0.7rem;
          padding:0.75rem 1.2rem;
          font-size:0.9rem;
          font-weight:600;
          cursor:pointer;
        }

      `}</style>

    </>
  );
}

function updateValue(
  fieldId,
  value,
  setCustomValues
) {

  setCustomValues((prev) => ({
    ...prev,
    [fieldId]: value,
  }));
}

function normalizeType(type) {

  switch (type) {

    case "paragraph":
      return "textarea";

    case "number":
      return "number";

    case "date":
      return "date";

    case "multiple":
      return "select";

    case "checkboxes":
      return "radio";

    case "text":
    default:
      return "text";
  }
}